<form [ngClass]="{'needs-validation': !frm.submitted, 'was-validated': frm.submitted}"
      novalidate #frm="ngForm" (ngSubmit)="onSalvar()">

  <div class="row">
    <div class="form-group mb-3 col-7">
      <label for="nome">Descrição</label>
      <input type="text" class="form-control" autocomplete="off" appAutoFocus [autoFocus]="true"
             id="nome" name="nome" [(ngModel)]="cupom.nome" #nome="ngModel"
             placeholder="Descrição para o cupom" value="" required/>
      <div class="invalid-feedback">
        <p *ngIf="nome.errors?.required">Descrição do cupom é obrigatório</p>
      </div>
    </div>

    <div class="form-group mb-3 col-5">
      <label for="codigo">Código</label>
      <div class="input-group">
         <input id='codigo'  name="codigo" minlength="5" mask-="AAAAAZZZZZZZZZZ"   class="form-control"
               placeholder="minimo 5 caracteres" required  type="text"  [(ngModel)]="cupom.codigo" #codigo="ngModel">

        <div class="input-group-append" (click)="gereCodigoCupom()" title="gerar aleátorio" kendoTooltip  >
          <span class="input-group-text">
                <i class="fa fa-random cpointer" ></i>
          </span>
        </div>

      </div>
    </div>

    <div class="form-group mb-3 col-5">
      <label for="codigo">Tipo do cupom</label>

      <div class="input-group mt-2">
        <ng-container *ngFor="let tipo of tiposDeCupoms" >
          <ng-container  *ngIf="!cupom.id || cupom.tipo === tipo">
            <input id="tipoCupom{{tipo}}" name="tipoCupom" type="radio"  class="k-radio"   kendoRadioButton
                   [(ngModel)]="cupom.tipo" [value]="tipo"
                   [required]="true"/>

            <label for="tipoCupom{{tipo}}" class="ml-1 mr-1">{{tipo}}</label>
          </ng-container>

        </ng-container>

        <div class="invalid-feedback" *ngIf="!cupom.tipo">
          Informe um tipo
        </div>
      </div>
    </div>

    <div class="form-group mb-3 col-3" *ngIf="cupom.tipo === EnumTipoDeCupom.Valor">
      <label for="valor">Valor</label>
      <div class="input-group">
        <kendo-numerictextbox [attr.type]="'number'" id="valor"    name="valor"  class="form-control" format="c2"
                              [(ngModel)]="cupom.valor"
                              required    >
        </kendo-numerictextbox>
        <div class="invalid-feedback" >
          Informe um valor para o cupom
        </div>
      </div>
    </div>

    <div class="form-group mb-3 col-3" *ngIf="cupom.tipo === EnumTipoDeCupom.Percentual">
      <label for="percentual">Percentual</label>
      <div class="input-group">
        <kendo-numerictextbox  [attr.type]="'number'" id="percentual"    name="percentual"  class="form-control"
                               [(ngModel)]="cupom.percentual" [min]="1" [max]="100"
                               [format]="obtenhaFormatoPercentual()"
                               required     >
        </kendo-numerictextbox>
        <div class="invalid-feedback" >
          Informe um percentual para o cupom
        </div>
      </div>
    </div>

    <div class="form-group mb-3 col-4">
      <label for="validade">Data validade</label>

      <div class="input-group">

        <kendo-datepicker [(ngModel)]="cupom.validade" id="validade"    name="validade" [format]="'dd/MM/yyyy'"
                          class="form-control   k-display-inline-block"  [min]="hoje" >
          <kendo-datepicker-messages
            today="Hoje"
            toggle="Alterar data"
          ></kendo-datepicker-messages>

        </kendo-datepicker>

      </div>
    </div>

  </div>

  <!-- escopo do cupom: app ou site, ou ambos -->
  <div class="row">
    <div class="col">
      <div class="form-group mb-3">
        <label>Onde o cupom é válido?</label>
        <div class="input-group">
          <input id="escopo0" name="escopo" type="radio"  class="k-radio"   kendoRadioButton
                 [(ngModel)]="cupom.escopo" [value]="'livre'" >
          <label for="escopo0" class="k-radio-label">&nbsp;Livre</label>
          <input id="escopo1" name="escopo" type="radio"  class="ml-1 k-radio"   kendoRadioButton
                 [(ngModel)]="cupom.escopo" [value]="'loja'" >
          <label for="escopo1" class="k-radio-label">&nbsp;Apenas no cardápio</label>
          <input id="escopo2" name="escopo" type="radio"  class="ml-1 k-radio"   kendoRadioButton
                 [(ngModel)]="cupom.escopo" [value]="'app'" >
          <label for="escopo2" class="k-radio-label">&nbsp;Apenas no Aplicativo</label>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <p>Disponibilizar apenas em dias específicos da semana</p>
      <p class="k-block">
        <button type="button" class="mr-1"  kendoButton (selectedChange)="onSelectedChange(ds, $event)" *ngFor="let ds of disponibilidadesSemana"
                [look]="'outline'"     [toggleable]="true" [selected]="ds.disponivel"  >{{ds.label}}</button>


      </p>
    </div>
  </div>

  <div class="row ">
    <div class="col">
      <div class="input-group mt-1 mb-2">
        <input  name="selecionavel" id='selecionavel'    class="k-checkbox  " type="checkbox"
                [(ngModel)]="cupom.selecionavel"/>
        <label  class="k-checkbox-label" for="selecionavel">Exibir cupom na loja para ser selecionado</label>


      </div>
    </div>
  </div>

  <fieldset>
    <legend>
      <label  >Restringir uso do cupom</label>
    </legend>

    <div class="row">
      <div class="form-group col-3 mb-2  mt-2"  >
        <label  >Quantidade</label>
        <div class="input-group">
          <kendo-numerictextbox [attr.type]="'number'"   #quantidade  class="form-control"
                                format="n0"   name="quantidade" [min]="0"
                                [(ngModel)]="cupom.quantidade" >
          </kendo-numerictextbox>

        </div>
      </div>

      <div class="form-group col-4 mb-2  mt-2"  >
        <label  >Máxima por usuário </label>
        <div class="input-group">
          <kendo-numerictextbox [attr.type]="'number'"   #qtdeMaxima class="form-control"
                                format="n0"   name="qtdeMaxima" [min]="0"
                                [(ngModel)]="cupom.qtdeMaxima" >
          </kendo-numerictextbox>

        </div>
      </div>

      <div class="form-group col-5 mb-2  mt-2"  >
        <label  >Valor mínimo <b>do pedido</b> </label>
        <div class="input-group">
          <kendo-numerictextbox [attr.type]="'number'" id="valorMinimo" #valorMinimo  class="form-control"
                                format="c2"   name="valorMinimo" [min]="0"
                                [(ngModel)]="cupom.valorMinimo" >
          </kendo-numerictextbox>

        </div>
      </div>

      <div class="form-group mb-2 col-7">

        <div class="input-group mt-2">
          <input  name="sempreReceberPedidos" id='sempreReceberPedidos'    class="k-checkbox  " type="checkbox"
                  [(ngModel)]="cupom.restrito"/>
          <label  class="k-checkbox-label" for="sempreReceberPedidos">Restrito a uma lista de contatos</label>


        </div>

      </div>

      <div class="form-group mb-2 col-5">

        <div class="input-group mt-2">
          <input  name="primeiraCompra" id='primeiraCompra'    class="k-checkbox  " type="checkbox"
                  [(ngModel)]="cupom.primeiraCompra"/>
          <label  class="k-checkbox-label" for="primeiraCompra">Exclusivo para 1° compra</label>


        </div>

      </div>

      <div class="form-group mb-2 col-12 " >
        <div class="input-group mt-2">
          <input  name="restritoContatoPerdido" id='restritoContatoPerdido'    class="k-checkbox  " type="checkbox"
                  [(ngModel)]="cupom.restritoContatoPerdido"/>
          <label  class="k-checkbox-label"  for="restritoContatoPerdido">Restringir uso apenas contatos perdidos</label>


        </div>
      </div>

      <div class="form-group mb-2 col-12">

        <div class="input-group">
          <input  name="aplicarNaTaxaDeEntrega" id='aplicarNaTaxaDeEntrega'    class="k-checkbox  " type="checkbox"
                  [(ngModel)]="cupom.aplicarNaTaxaDeEntrega"  [disabled]="cupom.aplicarNaFidelidade" />
          <label  class="k-checkbox-label" for="aplicarNaTaxaDeEntrega">Aplicar desconto exclusivamente na taxa de entrega</label>
        </div>

      </div>

      <div class="form-group mb-2 col-12" *ngIf="cupom.tipo === EnumTipoDeCupom.Percentual">

        <div class="input-group mt-2">
          <input  name="aplicarNaFidelidade" id='aplicarNaFidelidade'   [disabled]="cupom.naoPontuarFidelidade || cupom.aplicarNaTaxaDeEntrega"
                  class="k-checkbox  " type="checkbox"  [(ngModel)]="cupom.aplicarNaFidelidade"/>
          <label  class="k-checkbox-label" for="aplicarNaFidelidade">Utilizar cupom para turbinar cashback do programa fidelidade</label>


        </div>

      </div>

      <div class="form-group mb-2 col-6">

        <div class="input-group mt-2">
          <input  name="naoPontuarFidelidade" id='naoPontuarFidelidade' [disabled]="cupom.aplicarNaFidelidade"   class="k-checkbox  " type="checkbox"
                  [(ngModel)]="cupom.naoPontuarFidelidade"/>
          <label  class="k-checkbox-label" for="naoPontuarFidelidade">Não pontuar fidelidade</label>


        </div>

      </div>

      <div class="input-group mt-2 col-12">
        <input  name="naoAplicarProdutosComDesconto" id='naoAplicarProdutosComDesconto'    class="k-checkbox  " type="checkbox"
                [(ngModel)]="cupom.naoAplicarProdutosComDesconto"/>
        <label  class="k-checkbox-label" for="naoAplicarProdutosComDesconto"> Não aplicar cupom em produtos com descontos acima de: </label>

      </div>

      <div class="input-group mt-2 col-sm-4 col-6"  >
        <div class=" ml-4">
          <kendo-numerictextbox   [attr.type]="'number'" [min]="0.1" [max]="100"  class="form-control" name="valorMaximoDescontoProduto" #valorMaximoDescontoProduto=ngModel
                                  [disabled]="!cupom.naoAplicarProdutosComDesconto"
                                  [format]="obtenhaFormatoPercentual()" [required]="cupom.naoAplicarProdutosComDesconto"
                                  [(ngModel)]="cupom.percentualMaximoDescontoProduto" required>
          </kendo-numerictextbox>

          <div class="invalid-feedback">
            <p *ngIf="valorMaximoDescontoProduto.errors?.required">Informe o percentual de desconto</p>
            <p *ngIf="valorMaximoDescontoProduto.errors?.minError">Valor mínimo é  {{valorMaximoDescontoProduto.errors?.minError?.minValue}}</p>
            <p *ngIf="valorMaximoDescontoProduto.errors?.maxError">Valor máximo é  {{valorMaximoDescontoProduto.errors?.maxError?.maxValue}}</p>

          </div>
        </div>
      </div>

      <div class="input-group mt-2 col-sm-8 col-6  "  >

        <div class="input-group mt-0">
          <input  name="permitirComprarComPromocao" id="permitirComprarComPromocao"  class="k-checkbox  " type="checkbox" [disabled]="!cupom.naoAplicarProdutosComDesconto"
                  [(ngModel)]="cupom.permitirComprarComPromocao"/>
          <label  class="k-checkbox-label" for="permitirComprarComPromocao">Permitir que o cupom seja aplicado em   <br> outros produtos do carrinho </label>


        </div>

      </div>

      <div class="form-group mb-3 col-12  mt-2" *ngIf="tamanhosPizzas.length">
        <label  >Aplicar desconto somente em pizzas do tamanho</label><br>
        <kendo-dropdownlist class="form-control" name="tamanhoTemplate"
                            (selectionChange)="alterouComboProduto($event)"
                            [data]="tamanhosPizzas"
                            [filterable]="false"
                            [textField]="'descricao'" [valueField]="'id'"
                            [(ngModel)]="cupom.produtoTemplateTamanho"
        >
        </kendo-dropdownlist>

      </div>

      <div class="form-group mb-3 col-12 "  >
        <label  >Apenas se o produto de uma categoria estiver no carrinho</label><br>

        <kendo-dropdownlist class="form-control" name="categoria"
                            (selectionChange)="alterouComboProduto($event)"
                            [data]="categorias"
                            [filterable]="true"
                            [textField]="'nome'" [valueField]="'id'"
                            [(ngModel)]="cupom.categoria"
                            (filterChange)="searchCategoria($event)"
        >
        </kendo-dropdownlist>

      </div>

      <div class="form-group mb-3 col-12"  >
        <label  >Apenas se o produto estiver no carrinho</label><br>

        <kendo-dropdownlist class="form-control" name="produto"
          [data]="produtos"   (selectionChange)="alterouComboProduto($event)"
          [filterable]="true"
          [textField]="'descricao'" [valueField]="'id'"
          [(ngModel)]="cupom.produto"
          (filterChange)="search($event)"
          (focus)="busquePrimeiraVez()"
        >
        </kendo-dropdownlist>

      </div>


      <ng-container *ngIf="cupom.valorMinimo">
        <div class="form-group mb-3 col-12 " *ngIf="cupom.produtoTemplateTamanho">
          <div class="input-group mt-0" >
            <input  name="minimoApenasMesmoTamanho" id='minimoApenasMesmoTamanho'    class="k-checkbox  " type="checkbox"
                    [(ngModel)]="cupom.minimoApenasMesmoTamanho"  />
            <label  class="k-checkbox-label" for="minimoApenasMesmoTamanho">
              <b>Valor mínimo pedido</b> composto apenas por pizzas mesmo tamanho</label>

          </div>
        </div>


        <div class="form-group mb-3 col-12 "
             *ngIf="cupom.produto?.id || cupom.categoria?.id || cupom.produtoTemplateTamanho?.id">

          <div class="input-group mt-0">
            <input  name="produtoNaoComporMinimo" id='produtoNaoComporMinimo'    class="k-checkbox  " type="checkbox"
                    [(ngModel)]="cupom.produtoNaoComporMinimo" [disabled]="cupom.minimoApenasNoValorProduto" />
            <label  class="k-checkbox-label" for="produtoNaoComporMinimo">
              Produto(s) não compor o <b>valor mínimo do pedido</b></label>

          </div>

        </div>


        <div class="form-group mb-3 col-12 "
             *ngIf="cupom.produto?.id || cupom.categoria?.id || cupom.produtoTemplateTamanho?.id">

          <div class="input-group mt-0">
            <input  name="minimoApenasNoValorProduto" id='minimoApenasNoValorProduto'    class="k-checkbox  " type="checkbox"
                    [(ngModel)]="cupom.minimoApenasNoValorProduto" [disabled]="cupom.produtoNaoComporMinimo"/>
            <label  class="k-checkbox-label" for="minimoApenasNoValorProduto">
              <b>Valor mínimo pedido</b> será composto apenas pelos produtos</label>

          </div>

        </div>


        <div class="form-group mb-3 col-12 ">
          <label  >Exibir mensagem erro valor mínimo</label><br>
                <textarea class="form-control" id="mensagemMinimo"
                          rows="3" name="mensagemMinimo" [(ngModel)]="cupom.mensagemMinimo" #mensagemMinimo="ngModel" #textArea
                               ></textarea>
        </div>


      </ng-container>


    </div>
  </fieldset>

  <div class="alert alert-danger" role="alert" *ngIf="mensagemErro">
    <i class="fas fa-exclamation-triangle"></i> <span class="msg-erro">
    {{mensagemErro}}
  </span>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn btn-primary waves-effect waves-light" [disabled]="salvando" >Salvar</button>
    <button type="button" (click)="fechar()" primary="true"  class="btn btn-light waves-effect">Cancelar</button>
  </div>


</form>
